<div [formGroup]="parentForm">
      <label [attr.data-testid]="internalSelectModel.controlName + '-label'" for="{{internalSelectModel.controlName}}"
          [ngClass]="hasError ? 'error-text' : 'prompt'">{{internalSelectModel.title}}
          <span id="selectDropdown_optional-label" class="sdps-form-element__label-help"
            [attr.data-testid]="internalSelectModel.controlName + '-optional-label'"
            *ngIf="internalSelectModel.showOptionalLabel">(optional)
          </span>
          <mm-tooltip *ngIf="tooltipVerbiage || tooltipHtml" [position]="'right'" [containsLink]="false" id="selectDropdown_Tooltip" data-testid="selectDropdown_Tooltip">
              <tooltip-content>
                  <span [innerText]="tooltipVerbiage"></span>
                  <span slot="tooltip-content" [innerHTML]="tooltipHtml"></span>
              </tooltip-content>
              <tooltip-trigger-element>
                  <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
              </tooltip-trigger-element>
          </mm-tooltip>
      </label>
    <div class="dropdown-container">
        <select id="{{internalSelectModel.controlName + '_select'}}" class="sdps-dropdown__select"
            [attr.data-testid]="internalSelectModel.controlName + '-select'"
            [ngClass]="hasError ? 'error-prompt' : 'prompt'" name="{{internalSelectModel.controlName}}"
            formControlName="{{internalSelectModel.controlName}}">
            <option value="" disabled>
                 {{ isIrsDropdown ? irsPlaceholder : 'Select one' }}
            </option>
            <option *ngIf="showBlankOption" value=""></option>
            <option *ngFor="let option of internalSelectModel.options" [value]="option.value"
                [attr.data-testid]="option.value + '-option'">{{option.name}}</option>
        </select>
        <span aria-hidden="true" class="sdps-dropdown__icon sch-chevron-small-down"></span>
    </div>
    <div *ngIf="hasError" class="alert-box">
        <div class="alert-text"
         [ngClass]= "internalSelectModel.controlName == 'trustTaxCategory' || internalSelectModel.controlName == 'trustTaxCode'  ? 'alert-text-error': ''" [attr.data-testid]="internalSelectModel.controlName + '-error'">
            {{errorText}}
        </div>
    </div>
</div>
